import React from 'react';
import { Trans } from 'react-i18next';
import { Dialog } from '../dialog/Dialog';
import { useTranslation } from '../../localization/useAppTranslation';
import type { SavedPrompt } from '../../types/preferences';
import '../../styles/SavedPromptDialog.css';

interface SavedPromptDeleteDialogProps {
  isOpen: boolean;
  prompt: SavedPrompt;
  isDeleting: boolean;
  error: string | null;
  onConfirm: () => Promise<void>;
  onClose: () => void;
}

export const SavedPromptDeleteDialog: React.FC<SavedPromptDeleteDialogProps> = ({
  isOpen,
  prompt,
  isDeleting,
  error,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation('preferences');
  const requestClose = () => {
    if (!isDeleting) {
      onClose();
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      title={t('savedPrompts.deleteDialog.title')}
      onRequestClose={requestClose}
      className="saved-prompt-confirmation-dialog"
      footer={(
        <>
          <button
            type="button"
            className="dialog-button dialog-button-secondary"
            onClick={requestClose}
            disabled={isDeleting}
          >
            {t('common:actions.cancel')}
          </button>
          <button
            type="button"
            className="dialog-button dialog-button-danger"
            onClick={() => void onConfirm()}
            disabled={isDeleting}
          >
            {isDeleting ? t('savedPrompts.deleteDialog.deleting') : t('savedPrompts.actions.delete')}
          </button>
        </>
      )}
    >
      <p>
        <Trans
          ns="preferences"
          i18nKey="savedPrompts.deleteDialog.confirmation"
          values={{ title: prompt.title }}
          components={{ strong: <strong /> }}
        />
      </p>
      {error && <div className="saved-prompt-editor-error" role="alert">{error}</div>}
    </Dialog>
  );
};